import actions from './actions/actions'
import mutations from './mutations/mutation'
const state = {
  goodsImgList:[], // 商品详情信息上传的图片列表
  videoUrl: '', // 视频上传的url
  editorInfo: '', // 1编辑器上传内容 
  editorInfos: '', // 1编辑器上传内容 
  kindInfo: { // 规格基本信息
    kindinfo:'',//规格名称
    kindcontent:'', //规格内容
    goodsprice:'',//原售价
    goodsmallprice:'',//一口价
    specImgUrl:'',//规格配图
    showpos:'',//展示顺序
    postageWeight:'',//邮费计重
    bsale:1, // 上下架
    unshelvememo:'', // 下架备注
    electsmallprice: '', // 电子券价格 券卡和消费卡
  },
  stockInfo: {
    saleinv: 0, // 商城销售库存
    exchangeinv: 0, // 券卡兑换库存
    shareinv: 0, // 仓分享公共库存
    dailyinv: 0, // 每日初始库存
    opendaily: 0, // 是否开通每日库存
  },
  channelInfo: [], // 规格选择的销售渠道
  imgUrl: [], // 单个图片上传的地址
  voiceUrl: '', // 音频上传的url
  goodsDet: {
    pcContent: '', // pc端的商品详情
    mobContent: '', // 移动端的商品详情
  },
  cheditorImgUpd: false, // 编辑器图片上传标识
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/goodsStore/goodsStore.js